import React from 'react';
import { useLang } from '@/context/LanguageContext';
import { LANGS } from '@/i18n/translations';

export const LanguageSelector = ({ compact = false }) => {
  const { lang, setLang } = useLang();
  return (
    <div
      data-testid="language-selector"
      className="inline-flex items-center rounded-full border border-[var(--cea-border)] bg-[#0b241b]/80 backdrop-blur p-1"
    >
      {LANGS.map((l) => {
        const active = l.code === lang;
        return (
          <button
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => setLang(l.code)}
            aria-pressed={active}
            className={`px-3 py-1 text-xs font-bold tracking-[0.08em] rounded-full transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--cea-accent)] ${
              active
                ? 'bg-[var(--cea-accent)] text-[#040f0c] cea-glow'
                : 'text-white/70 hover:text-white'
            }`}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
};
